import {
  Box,
  CircularProgress,
  Menu,
  MenuItem,
  Typography,
  styled,
} from "@mui/material";
import React from "react";
import { IAppInfo } from "../../interfaces/dto/app.dto";
import { IWithClassName } from "../../theme/default.theme";
import { useAppDispatch } from "../../redux/store";
import { addAppThunk } from "../../redux/thunks/app.thunk";
import { AppType } from "../../enum/app";

interface IMenu extends IWithClassName {
  anchorEl: HTMLElement | null;
  options: Array<IAppInfo>;
  setAnchorEl: (value: HTMLElement | null) => void;
  appType: AppType;
  setAppAlert: (value: { open: boolean; isSuccess: boolean }) => void;
}

const AppMenu = ({
  anchorEl,
  options,
  setAnchorEl,
  className,
  appType,
  setAppAlert,
}: IMenu) => {
  const dispatch = useAppDispatch();

  const saveApp = async (appInfo: IAppInfo) => {
    const result = await dispatch(
      addAppThunk({
        author: appInfo.author,
        bundleId: appInfo.bundle_id,
        name: appInfo.title,
        type: appType,
        packageId: appInfo.product_id,
        rating: appInfo.rating,
        url: appInfo.link,
        thumbnail: appInfo.thumbnail,
      }),
    );

    setAppAlert({ open: true, isSuccess: result });

    setAnchorEl(null);
  };

  return (
    <Menu
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      className={className}
    >
      {options.length === 0 && (
        <MenuItem>
          <CircularProgress />
        </MenuItem>
      )}
      {options.map((option) => (
        <MenuItem key={option.title} onClick={() => saveApp(option)}>
          <img src={option.thumbnail} alt={option.title} height="40" />
          <Box>
            <Typography variant="h6">{option.title}</Typography>
            <Typography color="text.secondary">{option.author}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default styled(AppMenu)(() => ({
  width: 400,
  ".MuiMenuItem-root": {
    width: 400,
    justifyContent: "center",
    display: "grid",
    gridTemplateColumns: "70px 1fr",
    h6: {
      fontSize: 14,
    },
    p: {
      fontSize: 12,
    },
  },
}));
